import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6438f680"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "dis-center"
};
var _hoisted_2 = {
  class: "fontSet"
};
var _hoisted_3 = {
  class: "fontSets"
};
import { onMounted, ref } from '@vue/runtime-core';
import { formateDateWeek, formateDateShm } from '@/utils/index'; // const selectQuery = ref()
// 动态时间

export default {
  __name: 'driver',
  setup: function setup(__props) {
    var newDate = ref({
      nowdate: '',
      nowdatehour: ''
    });
    onMounted(function () {
      setInterval(function () {
        newDate.value.nowdatehour = formateDateShm(new Date());
        newDate.value.nowdate = formateDateWeek(new Date());
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(newDate).nowdate), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(newDate).nowdatehour), 1)]);
    };
  }
};